// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.bun/css-loader@7.1.4+018dfbff5b436835/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.bun/css-loader@7.1.4+018dfbff5b436835/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.padding-0 {
  padding: 0 !important;
}

.full-width-autocomplete {
  max-width: 100% !important;
}

.full-width-autocomplete div {
  max-width: 100% !important;
}
`, "",{"version":3,"sources":["webpack://./src/onboard/components/onboard-components.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".padding-0 {\n  padding: 0 !important;\n}\n\n.full-width-autocomplete {\n  max-width: 100% !important;\n}\n\n.full-width-autocomplete div {\n  max-width: 100% !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
